function e(e) {
  return "string" == typeof e ? e[0].toUpperCase() + e.substr(1) : e;
}

var r = {
  accepted: function accepted(e) {
    return "من فضلك اقبل ال " + e.name;
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " يجب أن يأتي بعد " + a[0] + "." : e(n) + " يجب أن يكون تاريخ أحدث";
  },
  alpha: function alpha(r) {
    return e(r.name) + " يجب أن يحتوى على حروف أبجدية فقط.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " يمكن أن يحتوي على حروف أبجدية أو أرقام فقط.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " يجب أن يكون قبل " + a[0] + "." : e(n) + " يجب أن يكون تاريخ أقدم";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " يجب أن يقع بين " + t[0] + " و " + t[1] + "." : e(n) + " يجب ان يكون طوله بين " + t[0] + " و " + t[1] + " حرف.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " غير متطابق.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ليس على الصيغة الصحيحة, من فضلك استخدم هذه الصيغة " + a[0] : e(n) + " ليس على الصيغة الصحيحة.";
  },
  default: function _default(e) {
    e.name;
    return "هذه القيمة غير مناسبة.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ليس عنوان بريد الكتروني." : "من فضلك أدخل عنوان بريد الكتروني مناسب.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” لا تنتهي بنهاية صحيحة." : "نهاية هذه القيمة ليست صحيحة.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” ليس " + n + " صحيح." : "هذه القيمة ليست " + n + " صحيح.";
  },
  matches: function matches(r) {
    return e(r.name) + " ليست قيمة مسموح بها.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "يمكنك فقط ان تختار " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " لا يمكن أن يتجاوز " + t[0] + "." : e(n) + " لا يجب ان يزيد طوله عن " + t[0] + " حرف.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " يجب ان يكون من نوع " + (a[0] || "لا يسمح بأي نوع.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "يجب أن تختار على الأقل " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " يجب أن يكون أكبر من " + t[0] + "." : e(n) + " يجب أن يكون طوله أكبر من " + t[0] + " حرف.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” ليست قيمة مسموح بها ك" + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " يجب أن يكون رقم.";
  },
  required: function required(r) {
    return e(r.name) + " ضروري.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” لا تبدأ بقيمة صحيحة." : "هذه القيمة لا تبدأ بقيمة صحيحة.";
  },
  url: function url(e) {
    e.name;
    return "من فضلك أدخل رابط صحيح.";
  }
};

function n(e) {
  var n;
  e.extend({
    locales: (n = {}, n.ar = r, n)
  });
}

var a = {
  accepted: function accepted(e) {
    return "Si us plau accepta els " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ha de ser després de " + a[0] + "." : e(n) + " ha de ser una data posterior.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " només pot contenir lletres.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " només pot contenir lletres i números.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ha de ser abans de " + a[0] + "." : e(n) + " ha de ser una data anterior";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ha d'estar entre " + t[0] + " i " + t[1] + "." : e(n) + " ha de tenir entre " + t[0] + " i " + t[1] + " caràcters.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " no coincideix.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " no és una data vàlida, si us plau usi el format " + a[0] : e(n) + " no és una data vàlida.";
  },
  default: function _default(e) {
    e.name;
    return "Aquest camp no és vàlid.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no és un correu electrònic vàlid." : "Si us plau introdueixi un correu electrònic vàlid.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no acaba en un valor vàlid." : "Aquest camp no acaba en un valor vàlid.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” no és un " + n + " permès." : "Això no és un " + n + " permès.";
  },
  matches: function matches(r) {
    return e(r.name) + " no és un valor permès.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Només pots seleccionar " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ha de ser menor o igual que " + t[0] + "." : e(n) + " ha de ser menor o igual que " + t[0] + " caràcters.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " ha de ser de tipus: " + (a[0] || "No es permet el format d'arxius.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Necessites almenys " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ha de contenir almenys " + t[0] + "." : e(n) + " ha de contenir almenys " + t[0] + " caràcters.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” no és un " + r + " permès.";
  },
  number: function number(r) {
    return e(r.name) + " ha de ser un número.";
  },
  required: function required(r) {
    return e(r.name) + " és requerit.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no comença amb un valor vàlid." : "Aquest camp no comença amb un valor vàlid.";
  },
  url: function url(e) {
    e.name;
    return "Si us plau introdueixi una url vàlida.";
  }
};

function t(e) {
  var r;
  e.extend({
    locales: (r = {}, r.ca = a, r)
  });
}

var i = {
  accepted: function accepted(e) {
    return "Prosím potvrďte " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musí bý po " + a[0] + "." : e(n) + " musí být pozdější datum.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " může obsahovat pouze písmena.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " může obsahovat pouze písmena a čísla.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musí být před " + a[0] + "." : e(n) + " musí být dřívější datum.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí být mezi " + t[0] + " a " + t[1] + "." : e(n) + " délka musí být mezi " + t[0] + " a " + t[1] + " znaky.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " se neshoduje.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " není platné datum, použijte formát " + a[0] : e(n) + " není platné datum.";
  },
  default: function _default(e) {
    e.name;
    return "Toto pole není vyplěno správně.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” není platná e-mailová adresa." : "Zadejte platnou e-mailovou adresu.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nekončí správnou hodnotou." : "Toto pole nekončí správnou hodnotou.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” není povolená hodnota " + n + "." : "Toto není povolená hodnota " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " není povolená hodnota.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Můžete vybrat pouze " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí být menší nebo rovno " + t[0] + "." : e(n) + " musí být menší nebo rovno " + t[0] + " znaků.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " musí být typ: " + (a[0] || "Žádné typy souborů nejsou povolené.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Je potřeba nejméně " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí být nejméně " + t[0] + "." : e(n) + " musí být nejméně " + t[0] + " znaků.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” není povolená hodnota " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " musí být číslo.";
  },
  required: function required(r) {
    return "Pole " + e(r.name) + " je povinné.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nezačíná platnou hodnotou." : "Toto pole nezačíná platnou hodnotou.";
  },
  url: function url(e) {
    e.name;
    return "Zadejte platnou URL adresu.";
  }
};

function u(e) {
  var r;
  e.extend({
    locales: (r = {}, r.cs = i, r)
  });
}

var o = {
  accepted: function accepted(e) {
    return "Accepter venligst " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " skal være efter " + a[0] + "." : e(n) + " skal være en senere dato.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " kan kun indeholde bogstaver.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " kan kun indeholde bogstaver og tal.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " skal være før " + a[0] + "." : e(n) + " skal være en tidligere dato.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " skal være mellem " + t[0] + " og " + t[1] + "." : e(n) + " skal være mellem " + t[0] + " og " + t[1] + " tegn.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " matcher ikke.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " er ikke gyldig, brug venligst formatet " + a[0] : e(n) + " er ikke en gyldig dato.";
  },
  default: function _default(e) {
    e.name;
    return "Dette felt er ikke gyldigt.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” er ikke en gyldig email-adresse." : "Indtast venligst en gyldig email-adresse.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” slutter ikke med en gyldig værdi." : "Dette felt slutter ikke med en gyldig værdi.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” er ikke en tilladt " + n + "." : "Dette er ikke en tilladt " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " er ikke en gyldig værdi.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du kan kun vælge " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " skal være mindre end eller lig " + t[0] + "." : e(n) + " skal være mindre end eller lig " + t[0] + " tegn.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " skal være af typen: " + (a[0] || "Ingen tilladte filformater.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du skal vælge mindst " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " skal være mere end " + t[0] + "." : e(n) + " skal være mere end " + t[0] + " tegn.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” er ikke en gyldig " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " skal være et tal.";
  },
  required: function required(r) {
    return e(r.name) + " er påkrævet.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” starter ikke med en gyldig værdi." : "Dette felt starter ikke med en gyldig værdi.";
  },
  url: function url(e) {
    e.name;
    return "Indtast venligst en gyldig URL.";
  }
};

function s(e) {
  var r;
  e.extend({
    locales: (r = {}, r.da = o, r)
  });
}

var l = {
  accepted: function accepted(e) {
    return e.name + " erfordert Zustimmung.";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " muss auf " + a[0] + " folgen." : e(n) + " muss ein späteres Datum sein.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " darf nur Buchstaben enthalten.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " darf nur Buchstaben und Zahlen enthalten.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " muss vor " + a[0] + " sein." : e(n) + " muss ein früheres Datum sein.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " muss zwischen " + t[0] + " und " + t[1] + "." : e(n) + " muss zwischen " + t[0] + " und " + t[1] + " Zeichen lang sein.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " stimmt nicht überein.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ist nicht korrekt, bitte das Format " + a[0] + " benutzen." : e(n) + " ist kein gültiges Datum.";
  },
  default: function _default(e) {
    e.name;
    return "Das Feld hat einen Fehler.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "„" + r + "“ ist keine gültige E-Mail-Adresse." : "Bitte eine gültige E-Mail-Adresse eingeben.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "„" + r + "” endet nicht mit einem gültigen Wert." : "Dieses Feld endet nicht mit einem gültigen Wert";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "„" + e(a) + "“ ist kein gültiger Wert für " + n + "." : "Dies ist kein gültiger Wert für " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " ist kein gültiger Wert.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Es dürfen nur " + t[0] + " " + n + " ausgewählt werden.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " muss kleiner oder gleich " + t[0] + " sein." : e(n) + " muss " + t[0] + " oder weniger Zeichen lang sein.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " muss den Typ " + (a[0] || "Keine Dateien erlaubt") + " haben.";
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Es müssen mindestens " + t[0] + " " + n + " ausgewählt werden.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " muss größer als " + t[0] + " sein." : e(n) + " muss " + t[0] + " oder mehr Zeichen lang sein.";
  },
  not: function not(e) {
    var r = e.name;
    return "„" + e.value + "“ ist kein erlaubter Wert für " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " muss eine Zahl sein.";
  },
  required: function required(r) {
    return e(r.name) + " ist ein Pflichtfeld.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "„" + r + "” beginnt nicht mit einem gültigen Wert" : "Dieses Feld beginnt nicht mit einem gültigen Wert";
  },
  url: function url(r) {
    return e(r.name) + " muss eine gültige URL sein.";
  }
};

function m(e) {
  var r;
  e.extend({
    locales: (r = {}, r.de = l, r)
  });
}

var v = {
  accepted: function accepted(e) {
    return "Please accept the " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " must be after " + a[0] + "." : e(n) + " must be a later date.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " can only contain alphabetical characters.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " can only contain letters and numbers.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " must be before " + a[0] + "." : e(n) + " must be an earlier date.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " must be between " + t[0] + " and " + t[1] + "." : e(n) + " must be between " + t[0] + " and " + t[1] + " characters long.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " does not match.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " is not a valid date, please use the format " + a[0] : e(n) + " is not a valid date.";
  },
  default: function _default(e) {
    e.name;
    return "This field isn’t valid.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” is not a valid email address." : "Please enter a valid email address.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” doesn’t end with a valid value." : "This field doesn’t end with a valid value.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” is not an allowed " + n + "." : "This is not an allowed " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " is not an allowed value.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "You may only select " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " must be less than or equal to " + t[0] + "." : e(n) + " must be less than or equal to " + t[0] + " characters long.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " must be of the type: " + (a[0] || "No file formats allowed.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "You need at least " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " must be at least " + t[0] + "." : e(n) + " must be at least " + t[0] + " characters long.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” is not an allowed " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " must be a number.";
  },
  required: function required(r) {
    return e(r.name) + " is required.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” doesn’t start with a valid value." : "This field doesn’t start with a valid value.";
  },
  url: function url(e) {
    e.name;
    return "Please include a valid url.";
  }
};

function c(e) {
  var r;
  e.extend({
    locales: (r = {}, r.en = v, r)
  });
}

var f = {
  accepted: function accepted(e) {
    return "Por favor acepta los " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " debe ser luego de " + a[0] + "." : e(n) + " debe ser una fecha posterior.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " solo puede contener letras.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " solo puede contener letras y números.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " debe ser antes de " + a[0] + "." : e(n) + " debe ser una fecha anterior.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " debe estar entre " + t[0] + " y " + t[1] + "." : e(n) + " debe tener entre " + t[0] + " y " + t[1] + " caracteres.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " no coincide.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " no es una fecha válida, por favor use el formato " + a[0] : e(n) + " no es una fecha válida.";
  },
  default: function _default(e) {
    e.name;
    return "Este campo no es válido.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no es un correo electrónico válido." : "Por favor introduzca un correo electrónico válido.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no termina en un valor válido." : "Este campo no termina en un valor válido.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” no es un " + n + " permitido." : "Esto no es un " + n + " permitido.";
  },
  matches: function matches(r) {
    return e(r.name) + " no es un valor permitido.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Solo puedes seleccionar " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " debe ser menor o igual que " + t[0] + "." : e(n) + " debe ser menor o igual que " + t[0] + " caracteres.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " debe ser de tipo: " + (a[0] || "No se permite el formato de archivos.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Necesitas al menos " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " debe contener al menos " + t[0] + "." : e(n) + " debe contener al menos " + t[0] + " caracteres.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” no es un " + r + " permitido.";
  },
  number: function number(r) {
    return e(r.name) + " debe ser un número.";
  },
  required: function required(r) {
    return e(r.name) + " es requerido.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” no comienza con un valor válido." : "Este campo no comienza con un valor válido.";
  },
  url: function url(e) {
    e.name;
    return "Por favor introduzca una url válida.";
  }
};

function d(e) {
  var r;
  e.extend({
    locales: (r = {}, r.es = f, r)
  });
}

var g = {
  accepted: function accepted(e) {
    return "Merci d'accepter les " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " doit être postérieur à " + a[0] + "." : e(n) + " doit être une date ultérieure.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " peut uniquement contenir des lettres.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " peut uniquement contenir des lettres ou des chiffres";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " doit être antérieur à " + a[0] + "." : e(n) + " doit être une date antérieure.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " doit être compris entre " + t[0] + " et " + t[1] + "." : e(n) + " doit être compris entre " + t[0] + " et " + t[1] + " caractères.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " ne correspond pas.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " n'est pas valide.  Merci d'utiliser le format " + a[0] : e(n) + " n'est pas une date valide.";
  },
  default: function _default(e) {
    e.name;
    return "Ce champ n'est pas valide.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” n'est pas une adresse email valide." : "Merci d'entrer une adresse email valide.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ne termine pas par une valeur correcte." : "Ce champ ne termine pas par une valeur correcte.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” n'est pas un(e) " + n + " autorisé(e)." : "Cette valeur n'est pas un(e) " + n + " autorisé(e).";
  },
  matches: function matches(r) {
    return e(r.name) + " n'est pas une valeur autorisée.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Vous pouvez uniquement sélectionner " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " doit être inférieur ou égal à " + t[0] + "." : e(n) + " doit être inférieur ou égal à " + t[0] + " caractères.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " doit être de type: " + (a[0] || "Aucun format autorisé.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Vous devez sélectionner au moins " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " doit être supérieur à " + t[0] + "." : e(n) + " doit être plus long que " + t[0] + " caractères.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” n'est pas un(e) " + r + " autorisé(e).";
  },
  number: function number(r) {
    return e(r.name) + " doit être un nombre.";
  },
  required: function required(r) {
    return e(r.name) + " est obligatoire.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ne commence pas par une valeur correcte." : "Ce champ ne commence pas par une valeur correcte.";
  },
  url: function url(e) {
    e.name;
    return "Merci d'entrer une URL valide.";
  }
};

function y(e) {
  var r;
  e.extend({
    locales: (r = {}, r.fr = g, r)
  });
}

var h = {
  accepted: function accepted(e) {
    return "אנא קבל את ה" + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " חייב להיות אחרי " + a[0] + "." : e(n) + " חייב להיות תאריך יותר מאוחר.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " יכול להכיל אותיות בלבד.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " יכול להכיל אותיות ומספרים בלבד.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " חייב להיות לפני " + a[0] + "." : e(n) + " חייב להיות תאריך יותר מוקדם.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " חייב להיות בין " + t[0] + " ו-" + t[1] + "." : e(n) + " חייב להיות בין " + t[0] + " ו-" + t[1] + " אותיות.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " אינו תואם.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " אינו תאריך תקין, אנא השתמש בפורמט " + a[0] : e(n) + " אינו תאריך תקין.";
  },
  default: function _default(e) {
    e.name;
    return "השדה אינו תקין.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” אינו כתובת אימייל תקין." : "אנא הכנס כתובת אימייל תקין.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” אינו מסתיים בערך תקין." : "שדה זו אינו מסתיים בערך תקין.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” אינו " + n + " מורשה." : "ערך זו איננו " + n + " מורשה.";
  },
  matches: function matches(r) {
    return e(r.name) + " אינו ערך מורשה.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "אתה יכול לבחור רק " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " חייב להיות פחות או שוה ל-" + t[0] + "." : e(n) + " חייב להיות פחות או שוה ל-" + t[0] + " אותיות.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " חייב להיות מסוג של: " + (a[0] || "סוגי קבצים לא מורשים.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "אתה צריך לפחות " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " חייב להיות לפחות " + t[0] + "." : e(n) + " חייב להיות לפחות " + t[0] + " אותיות.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” אינו " + r + " מורשה.";
  },
  number: function number(r) {
    return e(r.name) + " חייב להיות מספר.";
  },
  required: function required(r) {
    return e(r.name) + " נדרש.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” אינו מתחיל בערך תקף." : "שדה זה אינו מתחיל בערך תקף.";
  },
  url: function url(e) {
    e.name;
    return "אנא כלול כתובת אתר חוקית.";
  }
};

function A(e) {
  var r;
  e.extend({
    locales: (r = {}, r.he = h, r)
  });
}

var p = {
  accepted: function accepted(e) {
    return "Kérlek fogadd el a(z) " + e.name + " mezőt.";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " után kell lennie " + a[0] + "." : e(n) + " későbbi dátumnak kell lennie.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " csak ábécé szerinti karaktereket tartalmazhat.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " csak betűket és számokat tartalmazhat.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " előtt kell lennie " + a[0] + "." : e(n) + " korábbi dátumnak kell lennie.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " között kell lennie " + t[0] + " és " + t[1] + "." : e(n) + " között kell lennie " + t[0] + " és " + t[1] + " karakter hosszú.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " nem egyezik.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " nem érvényes dátum, kérlek használd a " + a[0] + " formátumot." : e(n) + " nem érvényes dátum.";
  },
  default: function _default(e) {
    e.name;
    return "Ez a mező érvénytelen.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nem érvényes e-mail cím." : "Kérlek valós e-mail címet adj meg.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nem ér véget érvényes értékkel." : "Ez a mező nem ér véget érvényes értékkel.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” nem megengedett " + n + "." : "Ez nem megengedett " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " nem megengedett érték.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Csak választható " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " kisebbnek vagy egyenlőnek kell lennie " + t[0] + "." : e(n) + " kisebbnek vagy egyenlőnek kell lennie " + t[0] + " karakter hosszú.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " típusúnak kell lennie: " + (a[0] || "Nem engedélyezett fájlformátumok.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Legalább szükséges " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " legalább " + t[0] + "." : e(n) + " legalább " + t[0] + " karakter hosszú.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” nem megengedett " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " számnak kell lennie.";
  },
  required: function required(r) {
    return e(r.name) + " kötelező.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nem érvényes értékkel kezdődik." : "Ez a mező nem érvényes értékkel kezdődik.";
  },
  url: function url(e) {
    e.name;
    return "Kérlek érvényes ulr-t adj meg.";
  }
};

function b(e) {
  var r;
  e.extend({
    locales: (r = {}, r.hu = p, r)
  });
}

var k = {
  accepted: function accepted(e) {
    return "Per favore, accetta il campo " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " deve essere una data successiva al " + a[0] + "." : e(n) + " deve essere una data successiva a quella attuale.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " può contenere solo lettere.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " può contenere solo lettere e numeri.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " deve essere una data precedente al " + a[0] + "." : e(n) + " deve essere una data precedente a quella attuale.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve essere tra " + t[0] + " e " + t[1] + "." : e(n) + " deve avere una lunghezza compresa tra " + t[0] + " e " + t[1] + " caratteri.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " non corrisponde.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " non è una data valida. Per favore usa il formato " + a[0] : e(n) + " non è una data valida.";
  },
  default: function _default(e) {
    e.name;
    return "Questo campo non è valido.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” non è un indirizzo email valido." : "Per favore, inserisci un indirizzo email valido.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” non termina con un valore valido." : "Questo campo non termina con un valore valido.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” non è un valore valido per il campo " + n + "." : n + " invalido.";
  },
  matches: function matches(r) {
    return e(r.name) + " invalido.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Puoi selezionare al massimo " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve essere inferiore o uguale a " + t[0] + "." : e(n) + " deve essere inferiore o uguale a " + t[0] + " caratteri.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " deve essere del tipo: " + (a[0] || "Nessun formato file autorizzato.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Devi selezionare almeno " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve essere maggiore di " + t[0] + "." : e(n) + " deve essere più lungo di " + t[0] + " caratteri.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” non è un valore valido per il campo " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " deve essere un numero.";
  },
  required: function required(r) {
    return e(r.name) + " è un campo obbligatorio.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” non inizia con un valore valido." : "Questo campo non inizia con un valore valido.";
  },
  url: function url(e) {
    e.name;
    return "Per favore inserisci un URL valido.";
  }
};

function N(e) {
  var r;
  e.extend({
    locales: (r = {}, r.it = k, r)
  });
}

var z = {
  accepted: function accepted(e) {
    return e.name + "を承認してください。";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + "は " + a[0] + " 以降にしてください。" : e(n) + "はより後にしてください。";
  },
  alpha: function alpha(r) {
    return e(r.name) + "にはアルファベットのみ使用できます。";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + "には英数字のみ使用できます。";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + "は " + a[0] + " 以前にしてください。" : e(n) + "はより前にしてください。";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + "は" + t[0] + "から" + t[1] + "の間でなければなりません。" : e(n) + "は" + t[0] + "文字から" + t[1] + "文字でなければなりません。";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + "が一致しません。";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + "は有効な形式ではありません。次のフォーマットで入力してください: " + a[0] : e(n) + "は有効な形式ではありません。";
  },
  default: function _default(e) {
    e.name;
    return "有効な値ではありません。";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” は有効なメールアドレスではありません。" : "有効なメールアドレスを入力してください。";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” は有効な値で終わっていません。" : "有効な値で終わっていません。";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” は許可された" + n + "ではありません。" : "許可された" + n + "ではありません。";
  },
  matches: function matches(r) {
    return e(r.name) + "は許可された値ではありません。";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return n + "は" + t[0] + "項目しか選択できません。";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + "は" + t[0] + "以下でなければなりません。" : e(n) + "は" + t[0] + "文字以下でなければなりません。";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + "は次のファイル形式でなければなりません: " + (a[0] || "許可されたファイル形式がありません");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return n + "は" + t[0] + "項目以上選択してください。";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + "は" + t[0] + "以上でなければなりません。" : e(n) + "は" + t[0] + "文字以上でなければなりません。";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” は許可された" + r + "ではありません。";
  },
  number: function number(r) {
    return e(r.name) + "には数字のみ使用できます。";
  },
  required: function required(r) {
    return e(r.name) + "は必須項目です。";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” は有効な値で始まっていません。" : "有効な値で始まっていません。";
  },
  url: function url(e) {
    e.name;
    return "有効なURLを入力してください。";
  }
};

function j(e) {
  var r;
  e.extend({
    locales: (r = {}, r.ja = z, r)
  });
}

var w = {
  accepted: function accepted(e) {
    return e.name + " 승인해 주세요.";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " " + a[0] + " 이후이어야 합니다." : e(n) + " 미래의 날짜이어야 합니다.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " 알파벳만 사용할 수 있습니다.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " 문자와 숫자만 사용할 수 있습니다.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " " + a[0] + " 이전이어야 합니다." : e(n) + "이전이어야 합니다.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " " + t[0] + "와 " + t[1] + "사이이어야 합니다." : e(n) + " " + t[0] + "자애서 " + t[1] + "자 사이이어야 합니다.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " 일치하지 않습니다.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " 유효한 날짜 형식이 아닙니다. 다음과 같은 형식으로 입력해 주세요: " + a[0] : e(n) + "올바른 날짜 형식이 아닙니다.";
  },
  default: function _default(e) {
    e.name;
    return "유효하지 않은 값입니다.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” 유효한 이메일 주소가 아닙니다." : "유효한 이메일 주소를 입력해 주세요.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "”으로 끝내야합니다." : "유효한 값으로 끝나지 않습니다.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” 허용된 " + n + " 아닙니다." : n + " 허용된 값이 아닙니다.";
  },
  matches: function matches(r) {
    return e(r.name) + " 허용 된 값이 아닙니다.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return n + " " + t[0] + "개의 항목만 선택 가능합니다.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " " + t[0] + "이하이어야 합니다." : e(n) + " " + t[0] + "자 이하이어야 합니다.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " 다음과 같은 파일 형식이어야 합니다: " + (a[0] || "허용되는 파일 형식이 아닙니다.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return n + " " + t[0] + " 이상 선택해 주세요.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " " + t[0] + "이상이어야 합니다." : e(n) + " " + t[0] + "자 이상이어야 합니다.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” 허용된 " + r + " 아닙니다.";
  },
  number: function number(r) {
    return e(r.name) + " 숫자만 사용 가능합니다.";
  },
  required: function required(r) {
    return e(r.name) + " 필수 항목입니다.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” 유효한 값으로 시작하지 않습니다." : "유효한 값으로 시작하지 않습니다.";
  },
  url: function url(e) {
    e.name;
    return "유효한 URL을 입력해 주세요.";
  }
};

function x(e) {
  var r;
  e.extend({
    locales: (r = {}, r.ko = w, r)
  });
}

var W = {
  accepted: function accepted(e) {
    return "Vennligst aksepter " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " må være etter " + a[0] + "." : e(n) + " må være på en senere dato.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " kan kun inneholde bokstaver.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " kan kun inneholde bokstaver og tall.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " må være før " + a[0] + "." : e(n) + " må være en tidligere dato.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " må være mellom " + t[0] + " og " + t[1] + "." : e(n) + " må være mellom " + t[0] + " og " + t[1] + " tegn.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " matcher ikke.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " er ikke gyldig. Vennligst bruk formatet " + a[0] : e(n) + " er ikke en gyldig dato.";
  },
  default: function _default(e) {
    e.name;
    return "Dette feltet er ikke gyldig.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” er ikke en gyldig e-postadresse." : "Vennligst skriv inn en gyldig e-postadresse.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” slutter ikke med en gyldig verdi." : "Dette feltet slutter ikke med en gyldig verdi.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” er ikke et tillatt " + n + "." : "Dette er ikke et tillatt " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " er ikke en gyldig verdi.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du kan kun velge " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " må være mindre eller lik " + t[0] + "." : e(n) + " må være mindre eller lik " + t[0] + " tegn.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " må være av typen: " + (a[0] || "Ingen tillatte filformater.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du skal velge minst " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " må være større enn " + t[0] + "." : e(n) + " må være minst " + t[0] + " tegn.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” er ikke et tillatt " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " må være et tall.";
  },
  required: function required(r) {
    return e(r.name) + " er påkrevd.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” starter ikke med en gyldig verdi." : "Dette feltet starter ikke med en gyldig verdi.";
  },
  url: function url(e) {
    e.name;
    return "Vennligst skriv inn en gyldig URL.";
  }
};

function q(e) {
  var r;
  e.extend({
    locales: (r = {}, r.nb = W, r)
  });
}

var P = {
  accepted: function accepted(e) {
    return "Sta " + e.name + " toe.";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " moet na " + a[0] + " zijn." : e(n) + " moet een latere datum zijn.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " mag enkel letters bevatten.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " mag enkel letters en cijfers bevatten.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " moet voor " + a[0] + " zijn." : e(n) + " moet een eerdere datum zijn.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " moet tussen " + t[0] + " en " + t[1] + " zitten." : e(n) + " moet tussen " + t[0] + " en " + t[1] + " lang zijn.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " komt niet overeen.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " is geen geldige datum, het juiste format is " + a[0] : e(n) + " is geen geldige datum.";
  },
  default: function _default(e) {
    e.name;
    return "De invoer voor dit veld is niet geldig";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” is geen geldig e-mailadres." : "Voer een geldig e-mailadres in.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” eindigt niet op een geldige waarde." : "Dit veld eindigt niet op een geldige waarde.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” is niet toegestaan als " + n + "." : "Deze " + n + " is niet toegestaan.";
  },
  matches: function matches(r) {
    return e(r.name) + " is niet toegestaan.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Je kunt maximaal " + t[0] + " selecteren als " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " moet kleiner of gelijk zijn aan " + t[0] + "." : e(n) + " mag maximaal " + t[0] + " karakters bevatten.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " moet van dit type zijn: " + (a[0] || "Bestanden zijn niet toegestaan");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Je moet tenminste " + t[0] + " selecteren als " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " moet groter zijn dan " + t[0] + "." : e(n) + " moet tenminste " + t[0] + " karakters bevatten.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” is geen geldige " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " moet een getal zijn.";
  },
  required: function required(r) {
    return e(r.name) + " is verplicht.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” begint niet met een geldige waarde." : "Dit veld begint niet met een geldige waarde.";
  },
  url: function url(e) {
    e.name;
    return "Voer een geldige URL in.";
  }
};

function D(e) {
  var r;
  e.extend({
    locales: (r = {}, r.nl = P, r)
  });
}

var T = {
  accepted: function accepted(e) {
    return "Prašome priimti " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " turi būti po " + a[0] + "." : e(n) + " turi būti vėlesnė data.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " gali būti tik abėcėlės raidės.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " gali būti tik raidės ir skaičiai.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " turi būti prieš " + a[0] + "." : e(n) + " turi būti ankstesnė data.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " turi būti tarp " + t[0] + " ir " + t[1] + "." : e(n) + " turi būti tarp " + t[0] + " ir " + t[1] + " simbolių ilgio.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " nesutampa.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " neteisinga data, naudokite formatą " + a[0] : e(n) + " neteisinga data.";
  },
  default: function _default(e) {
    e.name;
    return "Šis laukas nėra validus.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nėra teisingas el. pašto adresas." : "Prašome įvesti galiojantį el. pašto adresą.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nesibaigia galiojančia reikšme." : "Šis laukas nesibaigia galiojančia reikšme.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” nėra tinkamas " + n + "." : "Tai netinkamas " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " nėra leistina reikšmė.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Galite pasirinkti tik " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " turi būti mažesnis arba lygus " + t[0] + "." : e(n) + " turi turėti mažiau arba lygiai " + t[0] + " simbolių.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " turi būti tokio tipo: " + (a[0] || "Neleidžiami jokie failų formatai.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Turi būti ne mažiau nei " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " turi būti ne mažiau nei " + t[0] + "." : e(n) + " turi būti ne mažiau " + t[0] + " simbolių.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” nėra leistinas " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " turi būti skaičius.";
  },
  required: function required(r) {
    return e(r.name) + " yra privalomas.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” neprasideda galiojančia reikšme." : "Šis laukas neprasideda galiojančia reikšme.";
  },
  url: function url(e) {
    e.name;
    return "Įveskite galiojantį URL.";
  }
};

function L(e) {
  var r;
  e.extend({
    locales: (r = {}, r.lt = T, r)
  });
}

var U = {
  accepted: function accepted(e) {
    return "Proszę zaakceptować " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musi być po " + a[0] + "." : e(n) + " musi być przyszłą datą.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " może zawierać wyłącznie znaki alfabetyczne.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " może zawierać wyłącznie liczby i litery.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musi być przed " + a[0] + "." : e(n) + " musi być wczesniejszą datą.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musi być pomiędzy " + t[0] + " oraz " + t[1] + "." : e(n) + " musi być pomiędzy " + t[0] + " oraz " + t[1] + " znaków.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " nie pasuje.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " nie jest poprawną datą, proszę użyć formatu " + a[0] : e(n) + " nie jest poprawną datą.";
  },
  default: function _default(e) {
    e.name;
    return "Pole nie jest poprawne.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nie jest poprawnym adresem email." : "Proszę podać poprawny adres email.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nie kończy się z poprawną wartością." : "Pole nie kończy się z poprawną wartością.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” jest niedozwoloną wartością pola " + n + "." : "Wartość jest niedozwolona w polu " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " nie jest dozwoloną wartością.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Możesz wybrać maksymalnie " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musi być mniejszy lub równy " + t[0] + "." : e(n) + " musi być mniejszy lub równy " + t[0] + " znaków.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " musi być typem: " + (a[0] || "Niedozwolone formaty plików.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Potrzeba przynajmniej " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musi mieć przynajmniej " + t[0] + "." : e(n) + " musi mieć przynajmniej " + t[0] + " znaków.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” jest niedozwoloną wartością " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " musi być liczbą.";
  },
  required: function required(r) {
    return e(r.name) + " jest wymagane.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nie zaczyna się z poprawną wartością." : "Pole nie zaczyna się z poprawną wartością.";
  },
  url: function url(e) {
    e.name;
    return "Proszę wprowadzić poprawny adres URL.";
  }
};

function V(e) {
  var r;
  e.extend({
    locales: (r = {}, r.pl = U, r)
  });
}

var E = {
  accepted: function accepted(e) {
    return "Por favor aceite o " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " deve ser posterior a " + a[0] + "." : e(n) + " deve ser uma data posterior.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " pode conter apenas letras.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " pode conter apenas letras e números.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " deve ser antes de " + a[0] + "." : e(n) + " deve ser uma data anterior.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve ser entre " + t[0] + " e " + t[1] + "." : e(n) + " deve ter entre " + t[0] + " e " + t[1] + " caracteres.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " não corresponde.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " não é válido, por favor use o formato " + a[0] : e(n) + " não é uma data válida.";
  },
  default: function _default(e) {
    e.name;
    return "Este campo não é válido.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” não é um e-mail válido." : "Por favor informe um e-mail válido.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” não termina com um valor válido." : "Este campo não termina com um valor válido.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” não é um " + n + " permitido." : "Isso não é um " + n + " permitido.";
  },
  matches: function matches(r) {
    return e(r.name) + " não é um valor válido.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Você deve selecionar apenas " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve ser menor ou igual a " + t[0] + "." : e(n) + " deve ter no máximo " + t[0] + " caracteres.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " deve ser no formato: " + (a[0] || "Formato de arquivo não permitido.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Você deve selecionar pelo menos " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " deve ser maior que " + t[0] + "." : e(n) + " deve ter mais de " + t[0] + " caracteres.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” não é um " + r + " válido.";
  },
  number: function number(r) {
    return e(r.name) + " deve ser um número.";
  },
  required: function required(r) {
    return e(r.name) + " é obrigatório.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” não começa com um valor válido." : "Este campo não começa com um valor válido.";
  },
  url: function url(e) {
    e.name;
    return "Por favor informe uma URL válida.";
  }
};

function R(e) {
  var r;
  e.extend({
    locales: (r = {}, r.pt = E, r)
  });
}

var M = {
  accepted: function accepted(e) {
    return "Пожалуйста, подтвердите " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " должна быть после " + a[0] + "." : e(n) + " должна быть дата после.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " может содержать только буквы.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " может содержать только буквы и цифры.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " должно быть раньше " + a[0] + "." : e(n) + " должно быть раньше.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    !(!Array.isArray(t) || !t[2]) && t[2];
    return isNaN(a), e(n) + " должно быть между " + t[0] + " и " + t[1] + ".";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " не совпадает.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " не является допустимой датой, пожалуйста, используйте формат " + a[0] : e(n) + " не является допустимой датой.";
  },
  default: function _default(e) {
    e.name;
    return "Это поле не является допустимым.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” недействительный адрес электронной почты." : "Пожалуйста, введите действительный адрес электронной почты.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” не заканчивается допустимым значением." : "Это поле не заканчивается допустимым значением.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” является ошибочным для " + n + "." : "Выбранное значение для " + n + " ошибочно.";
  },
  matches: function matches(r) {
    return e(r.name) + " не совпадает.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Вы можете выбрать только " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " должно быть меньше или равно " + t[0] + "." : "Количество символов " + e(n) + " должно быть меньше или равно " + t[0] + ".";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " должно быть файлом одного из следующих типов: " + (a[0] || "Не допустимые форматы файлов.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Должно быть не менее " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " должно быть не менее " + t[0] + "." : "Количество символов " + e(n) + " должно быть не менее " + t[0] + ".";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” не является допустимым " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " должны быть числом.";
  },
  required: function required(r) {
    return e(r.name) + " обязательное поле.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” должно начинаться действительным значением." : "Поле должно начинаться действительным значением.";
  },
  url: function url(e) {
    e.name;
    return "Пожалуйста, укажите действительный URL.";
  }
};

function B(e) {
  var r;
  e.extend({
    locales: (r = {}, r.ru = M, r)
  });
}

var F = {
  accepted: function accepted(e) {
    return "Prosím príjmi " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musí byť neskôr ako " + a[0] + "." : "Pre " + e(n) + " je potrebné zvoliť neskorší dátum.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " môže obsahovať len písmená.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " môže obsahovať len písmená a čísla.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " musí byť skôr než " + a[0] + "." : "Pre " + e(n) + " je potrebné zvoliť skorší dátum.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí byť medzi " + t[0] + " a " + t[1] + "." : e(n) + " musí mať od " + t[0] + " do " + t[1] + " znakov.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " sa nezhoduje.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " neobsahuje korektný dátum. Je potrebné použiť formát " + a[0] : e(n) + " neobsahuje korektný dátum.";
  },
  default: function _default(e) {
    e.name;
    return "Toto pole obsahuje chybu.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nie je platná emailová adresa." : "Prosím, uveď platnú emailovú adresu..";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nekončí povolenou hodnotou." : "Toto pole nekončí povolenou hodnotou.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” nie je povolená hodnota pre " + n + "." : "Toto nie je povolená hodnota pre " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " nie je povolená hodnota.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Je možné vybrať najviac " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí byť nanajvýš " + t[0] + "." : e(n) + " musí obsahovať nanajvýš " + t[0] + " znakov.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " musí byť typu: " + (a[0] || "Žiadne formáty nie sú povolené.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Je potrebné vybrať aspoň " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " musí byť aspoň " + t[0] + "." : e(n) + " musí obsahovať aspoň " + t[0] + " znakov.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” nie je povolená hodnota pre " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " musí byť číslo.";
  },
  required: function required(r) {
    return e(r.name) + " je povinné pole.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nezačína povolenou hodnotou." : "Toto pole nezačína povolenou hodnotou.";
  },
  url: function url(e) {
    e.name;
    return "Prosím, uveď platnú URL adresu.";
  }
};

function Z(e) {
  var r;
  e.extend({
    locales: (r = {}, r.sk = F, r)
  });
}

var C = {
  accepted: function accepted(e) {
    return "Molimo Vas da prihvatite " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " mora biti posle " + a[0] + "." : e(n) + " mora biti kasniji datum.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " može sadržati samo abecedne karaktere.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " može sadržati samo slova i brojeve.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " mora biti pre " + a[0] + "." : e(n) + " mora biti raniji datum.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " mora biti između " + t[0] + " i " + t[1] + "." : e(n) + " mora biti između " + t[0] + " i " + t[1] + " karaktera.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " se ne podudara.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " nije važeći datum, koristite format " + a[0] : e(n) + " nije važeći datum.";
  },
  default: function _default(e) {
    e.name;
    return "Ovo polje nije važeće.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” nije važeća e-mail adresa." : "Unesite ispravnu e-mail adresu.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” se ne završava važećom vrednošću." : "Ovo polje se ne završava važećom vrednošću.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” nije dozvoljeno " + n + "." : "Ovo nije dozvoljeno " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " nije dozvoljena vrednost za ovo polje.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Možete odabrati samo " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " mora biti manje ili jednako " + t[0] + "." : e(n) + " mora biti manje ili jednako " + t[0] + " karaktera.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " mora biti jedan sledecih formata: " + (a[0] || "Format datoteke nije dozvoljen.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Treba Vam bar " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " treba da ima najmanje " + t[0] + "." : e(n) + " treba da ima najmanje " + t[0] + " karaktera.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” nije dozvoljena vrednost za polje " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " mora biti broj.";
  },
  required: function required(r) {
    return e(r.name) + " je obavezno polje.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ne počinje sa važećom vrednošću." : "Ovo polje ne počinje sa važećom vrednošću.";
  },
  url: function url(e) {
    e.name;
    return "Unesite važeći url.";
  }
};

function I(e) {
  var r;
  e.extend({
    locales: (r = {}, r.sr = C, r)
  });
}

var J = {
  accepted: function accepted(e) {
    return "Var vänlig acceptera " + e.name + ".";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " måste vara efter " + a[0] + "." : e(n) + " måste vara ett senare datum.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " får bara innehålla bokstäver.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " får bara innehålla bokstäver och nummer.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " måste vara innan " + a[0] + "." : e(n) + " måste vara ett tidigare datum.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " måste vara mellan " + t[0] + " och " + t[1] + "." : e(n) + " måste vara mellan " + t[0] + " och " + t[1] + " tecken .";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " matchar inte.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " är inte ett giltigt datum, var vänlig och använd formatet " + a[0] : e(n) + " är inte ett giltigt datum.";
  },
  default: function _default(e) {
    e.name;
    return "Fältet är inte giltigt.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” är inte en giltigt e-postadress." : "Var vänlig och ange en giltig e-postadress.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” slutar inte med ett giltigt värde." : "Detta fält slutar inte med ett giltigt värde.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” är inte ett tillåtet " + n + "." : "Detta är inte ett tillåtet " + n + ".";
  },
  matches: function matches(r) {
    return e(r.name) + " är inte ett tillåtet värde.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du får bara välja " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " måste vara mer än eller lika med " + t[0] + "." : e(n) + " måste vara mindre än eller lika med " + t[0] + " tecken.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " måste vara av typen: " + (a[0] || "Inga filformat tillåtna.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Du måste välja minst " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " måste vara minst " + t[0] + "." : e(n) + " måste åtminstone vara " + t[0] + " tecken långt.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” är inte tillåtet " + r + ".";
  },
  number: function number(r) {
    return e(r.name) + " måste vara ett nummer.";
  },
  required: function required(r) {
    return e(r.name) + " är obligatoriskt.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” börjar inte med ett giltigt värde." : "Detta fält börjar inte med ett giltigt värde.";
  },
  url: function url(e) {
    e.name;
    return "Vänligen ange en giltig url.";
  }
};

function K(e) {
  var r;
  e.extend({
    locales: (r = {}, r.sv = J, r)
  });
}

var S = {
  accepted: function accepted(r) {
    return "กรุณายอมรับ " + e(r.name);
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ต้องเป็นวันที่หลังจาก " + a[0] : e(n) + " ต้องเป็นวันที่ยังไม่มาถึง";
  },
  alpha: function alpha(r) {
    return e(r.name) + " มีได้เฉพาะตัวอักษรเท่านั้น";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " มีได้เฉพาะตัวอักษรและตัวเลขเท่านั้น";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ต้องเป็นวันที่ก่อนหน้า " + a[0] : e(n) + " ต้องเป็นวันที่ผ่านมาแล้ว";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ต้องมีค่าระหว่าง " + t[0] + " ถึง " + t[1] : e(n) + " ต้องมีความยาว " + t[0] + " ถึง " + t[1] + " ตัว";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " ไม่ตรงกัน";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " ไม่ใช่วันที่ที่ถูกต้อง กรุณาใช้ตามรูปแบบ " + a[0] : e(n) + " ไม่ใช่วันที่ที่ถูกต้อง";
  },
  default: function _default(e) {
    e.name;
    return "ข้อมูลช่องนี้ไม่ถูกต้อง";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ไม่ใช่ที่อยู่อีเมลที่ถูกต้อง" : "กรุณากรอกที่อยู่อีเมลให้ถูกต้อง";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ไม่ได้ลงท้ายด้วยค่าที่ถูกต้อง" : "ข้อมูลช่องนี้ไม่ได้ลงท้ายด้วยค่าที่ถูกต้อง";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” ไม่ใช่ " + n + " ที่อนุญาตให้กรอก" : "นี่ไม่ใช่ " + n + " ที่อนุญาตให้กรอก";
  },
  matches: function matches(r) {
    return e(r.name) + " ไม่ใช่ค่าที่อนุญาตให้กรอก";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "คุณเลือกได้เพียง " + t[0] + " " + n + " เท่านั้น";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ต้องมีไม่เกิน " + t[0] : e(n) + " ต้องยาวไม่เกิน " + t[0] + " ตัว";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " ต้องเป็นประเภท: " + (a[0] || "ไม่มีประเภทไฟล์ที่อนุญาต");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "คุณต้องเลือกอย่างน้อย " + t[0] + " " + n;
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " ต้องมีค่าอย่างน้อย " + t[0] : e(n) + " ต้องยาวอย่างน้อย " + t[0] + " ตัว";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” ไม่ใช่ค่า " + r + " ที่อนุญาตให้กรอก";
  },
  number: function number(r) {
    return e(r.name) + " ต้องเป็นตัวเลข";
  },
  required: function required(r) {
    return e(r.name) + " จำเป็นต้องกรอก";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” ไม่ได้ขึ้นต้นด้วยค่าที่ถูกต้อง" : "ข้อมูลช่องนี้ไม่ได้ขึ้นต้นด้วยค่าที่ถูกต้อง";
  },
  url: function url(e) {
    e.name;
    return "กรุณาแนบลิงก์ให้ถูกต้อง";
  }
};

function O(e) {
  var r;
  e.extend({
    locales: (r = {}, r.th = S, r)
  });
}

var Q = {
  accepted: function accepted(e) {
    return "Lütfen " + e.name + "'i kabul edin..";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + ", " + a[0] + " sonrasında olmalıdır." : e(n) + " daha sonraki bir tarih olmalıdır.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " yalnızca alfabetik karakterler içerebilir.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " yalnızca harf ve rakam içerebilir.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + ", " + a[0] + " tarihinden önce olmalıdır." : e(n) + " daha erken bir tarih olmalıdır.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + ", " + t[0] + " ile " + t[1] + " arasında olmalıdır." : e(n) + ", " + t[0] + " ile " + t[1] + " karakter uzunluğunda olmalıdır.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " eşleşmiyor.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " geçerli bir tarih değil, lütfen " + a[0] + " biçimini kullanın" : e(n) + " geçerli bir tarih değil.";
  },
  default: function _default(e) {
    e.name;
    return "Bu alan geçerli değil.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” geçerli bir e-posta adresi değil." : "Lütfen geçerli bir e-posta adresi giriniz.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” geçerli bir değerle bitmiyor." : "Bu alan geçerli bir değerle bitmiyor.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” izin verilen bir " + n + " değil." : "Bu izin verilen bir " + n + " değil.";
  },
  matches: function matches(r) {
    return e(r.name) + " izin verilen bir değer değil.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Yalnızca " + t[0] + " " + n + " seçebilirsiniz.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + ", " + t[0] + " değerinden küçük veya ona eşit olmalıdır." : e(n) + ", " + t[0] + " karakterden küçük veya ona eşit olmalıdır.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " şu türde olmalıdır: " + (a[0] || "Dosya formatına izin verilmez.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "En az " + t[0] + " " + n + " gerekiyor.";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " en az " + t[0] + " olmalıdır." : e(n) + " en az " + t[0] + " karakter uzunluğunda olmalıdır.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” izin verilen bir " + r + " değil.";
  },
  number: function number(r) {
    return e(r.name) + " bir sayı olmalıdır.";
  },
  required: function required(r) {
    return e(r.name) + " gerekli.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” geçerli bir değerle başlamıyor." : "Bu alan geçerli bir değerle başlamıyor.";
  },
  url: function url(e) {
    e.name;
    return "Lütfen geçerli bir url ekleyin.";
  }
};

function Y(e) {
  var r;
  e.extend({
    locales: (r = {}, r.tr = Q, r)
  });
}

var G = {
  accepted: function accepted(e) {
    return e.name + " phải được chấp nhận.";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " phải sau ngày " + a[0] + "." : e(n) + " phải sau ngày hôm nay.";
  },
  alpha: function alpha(r) {
    return e(r.name) + " chỉ có thể chứa các kí tự chữ.";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " chỉ có thể chứa các kí tự chữ và số.";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " phải trước ngày ngày " + a[0] + "." : e(n) + " phải trước ngày hôm nay.";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " phải có giá trị nằm trong khoảng giữa " + t[0] + " and " + t[1] + "." : e(n) + " phải có giá trị dài từ " + t[0] + " đến " + t[1] + " ký tự.";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " không khớp.";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " không phải là định dạng của ngày, vui lòng sử dụng định dạng " + a[0] : e(n) + " không phải là định dạng của ngày.";
  },
  default: function _default(e) {
    e.name;
    return "Trường này không hợp lệ.";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” phải là một địa chỉ email hợp lệ." : "Vui lòng nhập địa chỉ email hợp lệ.";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” phải kết thúc bằng giá trị hợp lệ." : "Trường này phải kết thúc bằng giá trị hợp lệ.";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” phải khớp với " + n + "." : n + " phải khớp với giá trị cho phép.";
  },
  matches: function matches(r) {
    return e(r.name) + " phải khớp với giá trị cho phép.";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Bạn chỉ có thể chọn " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " phải nhỏ hơn hoặc bằng " + t[0] + "." : e(n) + " phải nhỏ hơn hoặc bằng " + t[0] + " ký tự.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " phải chứa kiểu tệp phù hợp: " + (a[0] || "Không có định dạng tệp nào được cho phép.");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "Phải chứa ít nhất " + t[0] + " " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " phải chứa ít nhất " + t[0] + "." : e(n) + " phải chứa ít nhất " + t[0] + " ký tự.";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” phải là " + r + " hợp lệ.";
  },
  number: function number(r) {
    return e(r.name) + " phải là số.";
  },
  required: function required(r) {
    return e(r.name) + " là bắt buộc.";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” phải bắt đầu bằng giá trị hợp lệ." : "Trường này phải bắt đầu bằng giá trị hợp lệ.";
  },
  url: function url(e) {
    e.name;
    return "Vui lòng nhập đúng định dạng url.";
  }
};

function H(e) {
  var r;
  e.extend({
    locales: (r = {}, r.vi = G, r)
  });
}

var X = {
  accepted: function accepted(e) {
    return "请同意" + e.name + "。";
  },
  after: function after(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " 必须在 " + a[0] + " 之后。" : e(n) + " 必须是以后的日期。";
  },
  alpha: function alpha(r) {
    return e(r.name) + " 只能包含字母。";
  },
  alphanumeric: function alphanumeric(r) {
    return e(r.name) + " 只能包含字母或数字。";
  },
  before: function before(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " 必须在 " + a[0] + " 之前" : e(n) + " 必须是以前的日期。";
  },
  between: function between(r) {
    var n = r.name,
        a = r.value,
        t = r.args,
        i = !(!Array.isArray(t) || !t[2]) && t[2];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " 必须在 " + t[0] + " 和 " + t[1] + " 之间。" : e(n) + " 必须在 " + t[0] + " 和 " + t[1] + " 字符长度之间。";
  },
  confirm: function confirm(r) {
    var n = r.name;
    r.args;
    return e(n) + " 不匹配。";
  },
  date: function date(r) {
    var n = r.name,
        a = r.args;
    return Array.isArray(a) && a.length ? e(n) + " 日期无效，请使用 " + a[0] + " 格式。" : e(n) + " 日期无效。";
  },
  default: function _default(e) {
    e.name;
    return "此输入无效。";
  },
  email: function email(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” 不是一个有效的电子邮箱地址。" : "请输入有效的电子邮箱地址。";
  },
  endsWith: function endsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” 包含无效的结尾值。" : "无效的结尾值。";
  },
  in: function _in(r) {
    var n = r.name,
        a = r.value;
    return "string" == typeof a && a ? "“" + e(a) + "” 是 " + n + " 不允许的值。" : n + " 包含不允许的值。";
  },
  matches: function matches(r) {
    return e(r.name) + " 包含不允许的值。";
  },
  max: function max(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "您最多可有 " + t[0] + " 个 " + n + "。";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " 必须小于或等于 " + t[0] + "." : e(n) + " 必须小于或等于 " + t[0] + " 字符长度.";
  },
  mime: function mime(r) {
    var n = r.name,
        a = r.args;
    return e(n) + " 格式必须是: " + (a[0] || "无允许文件格式");
  },
  min: function min(r) {
    var n = r.name,
        a = r.value,
        t = r.args;
    if (Array.isArray(a)) return "您需要最少 " + t[0] + " 个 " + n + ".";
    var i = !(!Array.isArray(t) || !t[1]) && t[1];
    return !isNaN(a) && "length" !== i || "value" === i ? e(n) + " 最少是 " + t[0] + "." : e(n) + " 最少 " + t[0] + " 字符长度。";
  },
  not: function not(e) {
    var r = e.name;
    return "“" + e.value + "” 是 " + r + " 不被允许的值。";
  },
  number: function number(r) {
    return e(r.name) + " 必须是数字。";
  },
  required: function required(r) {
    return e(r.name) + " 是必填项。";
  },
  startsWith: function startsWith(e) {
    e.name;
    var r = e.value;
    return r ? "“" + r + "” 包含无效的起始值" : "无效的起始值";
  },
  url: function url(e) {
    e.name;
    return "请输入正确的网址。";
  }
};

function $(e) {
  var r;
  e.extend({
    locales: (r = {}, r.zh = X, r)
  });
}

export { n as ar, t as ca, u as cs, s as da, m as de, c as en, d as es, y as fr, A as he, b as hu, N as it, j as ja, x as ko, L as lt, q as nb, D as nl, V as pl, R as pt, B as ru, Z as sk, I as sr, K as sv, O as th, Y as tr, H as vi, $ as zh };